import { trackFailure } from "@/lib/integrations/sentry-tracking";

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function createOnDataAvailable(
  chunksRef: { current: Blob[] },
  context: "audio" | "video" | "screen",
  onDataAvailable?: (data: ArrayBuffer) => void,
): (event: BlobEvent) => Promise<void> {
  return async (event) => {
    if (!event.data || event.data.size === 0) return;
    chunksRef.current.push(event.data);
    if (!onDataAvailable) return;
    try {
      const buffer = await event.data.arrayBuffer();
      onDataAvailable(buffer);
    } catch (err) {
      // The blob can transiently fail to read after the tab was backgrounded; one retry usually recovers.
      try {
        await delay(250);
        const buffer = await event.data.arrayBuffer();
        onDataAvailable(buffer);
      } catch (retryErr) {
        trackFailure("in_app_recorder", "chunk_write_failed", {
          context,
          error_reason: retryErr instanceof Error ? retryErr.message : String(retryErr),
        });
      }
    }
  };
}
